import ZkDropdownMenu from '../dropdown/src/dropdown-menu';

/* istanbul ignore next */
ZkDropdownMenu.install = function(Vue) {
  Vue.component(ZkDropdownMenu.name, ZkDropdownMenu);
};

export default ZkDropdownMenu;



// WEBPACK FOOTER //
// ./src/packages/dropdown-menu/index.js